import './About.css';
const About = () => {
  return (
    <section className="about" id="about">
      <div className="about-container">
        <div className="about-content">
          <span className="section-tag">About Us</span>
          <h2 className="section-title">Hyderabad's Most Trusted To-Let Service</h2>
          <p className="about-text">
            We help customers find genuine rental homes through verified properties. Our field executive personally visits each property to record complete data — showing rooms, washrooms, water taps, ventilation, surroundings, and more.
          </p>
          <p className="about-text">
            Only verified listings are shared with customers. We also provide moving assistance with trained manpower to make shifting simple and stress-free.
          </p>
          <div className="about-values">
            <div className="value-item">
              <div className="value-icon">🎯</div>
              <div>
                <h4 className="value-title">Our Mission</h4>
                <p className="value-desc">To simplify rentals by providing verified properties, transparent communication, and friendly customer support — ensuring everyone finds a safe and comfortable home.</p>
              </div>
            </div>
            <div className="value-item">
              <div className="value-icon">🌟</div>
              <div>
                <h4 className="value-title">Our Vision</h4>
                <p className="value-desc">To become Hyderabad's most trusted and friendly To-Let service — setting a new standard for honesty, convenience, and care.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="about-visual">
          <div className="about-card-stack">
            <div className="about-card about-card-1">
              <span className="about-card-emoji">🏠</span>
              <span className="about-card-text">Verified Homes</span>
            </div>
            <div className="about-card about-card-2">
              <span className="about-card-emoji">📦</span>
              <span className="about-card-text">Free Cartons</span>
            </div>
            <div className="about-card about-card-3">
              <span className="about-card-emoji">🚚</span>
              <span className="about-card-text">Moving Help</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default About;